<ion-header class="ion-no-border">
  <ion-item lines="full">
    <ion-button (click)="goBack()" id="back" tooltip="Back" aria-label="Go Back">
      <ion-icon src="/assets/icons/24px/chevron-left.svg" slot="icon-only"> </ion-icon>
    </ion-button>

    <ion-label id="edit-take-name" (click)="openEditTakeNameMenu($event)" tooltip="Edit Take Name">
      <h6 class="bold">
        <span *ngIf="take && take.takeName">{{ take.takeName }}</span>
        <span *ngIf="take && !take.takeName">Take {{ take.takeNumber }}</span>
      </h6>
    </ion-label>

    <ion-button
      *ngIf="recordingsReady"
      class="descript"
      (click)="editInDescript()"
      tooltip="Edit in Descript"
      aria-label="Edit in Descript">
      <span> Edit in Descript </span>
    </ion-button>

    <ion-button id="close" (click)="closeSidebar.emit()" tooltip="Close" aria-label="Close">
      <ion-icon src="/assets/icons/24px/close.svg" slot="icon-only"> </ion-icon>
    </ion-button>
  </ion-item>
</ion-header>

<ion-content>
  <ion-list *ngIf="(role$ | async) >= roleLimits.RECORDING_READ">
    <div *ngFor="let recording of recordings; trackBy: trackBy; last as last">
      <sc-recording-list-item
        [recordingID]="recording.recordingID"
        [sessionID]="recording.sessionID"
        [last]="last"
        appearance="take"></sc-recording-list-item>
    </div>
  </ion-list>
</ion-content>
